const roundNumericValue = (value) => {
  return typeof value === "number" ? Math.round(value) : void 0;
};
export {
  roundNumericValue
};
//# sourceMappingURL=utils.js.map
